import React from 'react';
import { getBrand } from "api/urls";
import { useHistory } from "react-router";
import { getQueryParams } from 'utils/Utils';
import BrandContainer from 'components/wrapper/BrandContainer';


const Brand = (props) => {

    const history = useHistory()
    const querryParams = getQueryParams(history.location.search)

    return (
        <div  {...props}>
            <BrandContainer
                url={getBrand(querryParams.company__symbol)}
                title={"Brands"}
            />
        </div>
    )
};

export default (Brand);
